"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var useTabSteps = function (type) {
    var tabsRefs = React.useRef([]);
    var _a = tslib_1.__read(React.useState([]), 2), steps = _a[0], setSteps = _a[1];
    var _b = tslib_1.__read(React.useState([]), 2), sizes = _b[0], setSizes = _b[1];
    var passRefsToArray = React.useCallback(function (index) { return function (el) {
        tabsRefs.current[index] = el;
    }; }, [tabsRefs]);
    React.useEffect(function () {
        var timer = setTimeout(function () {
            var _a;
            var sizes = (_a = tabsRefs === null || tabsRefs === void 0 ? void 0 : tabsRefs.current) === null || _a === void 0 ? void 0 : _a.map(function (tab) {
                return type === 'horizontal' ? tab.getBoundingClientRect().width : tab.getBoundingClientRect().height;
            });
            var sum = 0;
            var steps = sizes === null || sizes === void 0 ? void 0 : sizes.map(function (size) {
                sum = sum + size;
                return sum;
            });
            setSizes(sizes);
            setSteps(tslib_1.__spreadArray([0], tslib_1.__read((steps !== null && steps !== void 0 ? steps : [])), false));
        }, 400);
        return function () { return clearTimeout(timer); };
    }, [type]);
    return { passRefsToArray: passRefsToArray, steps: steps, sizes: sizes };
};
exports.default = useTabSteps;
